// =============================================================================
// FILE PATH : src/modules/pms/wbs_template/components/TemplateFilterBar.js
// MODULE    : PMS → WBS Template
// PURPOSE   : Smart Search + Filter Bar
// =============================================================================

import React from "react";


// -----------------------------------------------------------------------------
// STYLES
// -----------------------------------------------------------------------------
const containerStyle = {
  padding: "12px",
  borderBottom: "1px solid #e5e7eb",
  background: "#fafafa"
};

const searchInputStyle = {
  width: "100%",
  padding: "10px 12px",
  border: "1px solid #d1d5db",
  borderRadius: "6px",
  fontSize: "14px",
  marginBottom: "10px",
  outline: "none",
  boxSizing: "border-box"
};

const filterRowStyle = {
  display: "flex",
  gap: "10px",
  flexWrap: "wrap"
};

const selectStyle = {
  padding: "8px 10px",
  border: "1px solid #d1d5db",
  borderRadius: "6px",
  fontSize: "13px",
  minWidth: "160px",
  background: "#fff",
  cursor: "pointer"
};


// -----------------------------------------------------------------------------
// COMPONENT
// -----------------------------------------------------------------------------
const TemplateFilterBar = ({
  searchText,
  onSearchChange,

  categoryFilter,
  onCategoryChange,

  sortBy,
  onSortChange
}) => {

  return (
    <div style={containerStyle}>

      {/* SEARCH */}
      <input
        type="text"
        placeholder="🔍 Search templates, tasks, equipment, variant..."
        value={searchText}
        onChange={(e) => onSearchChange(e.target.value)}
        style={searchInputStyle}
      />

      {/* FILTERS */}
      <div style={filterRowStyle}>

        {/* CATEGORY FILTER */}
        <select
          value={categoryFilter}
          onChange={(e) => onCategoryChange(e.target.value)}
          style={selectStyle}
        >
          <option value="ALL">
            All Categories
          </option>

          <option value="CIVIL">
            CIVIL
          </option>

          <option value="MECHANICAL">
            MECHANICAL
          </option>

          <option value="ELECTRICAL">
            ELECTRICAL
          </option>
        </select>

        {/* SORT */}
        <select
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value)}
          style={selectStyle}
        >
          <option value="NAME">
            Sort by Name
          </option>

          <option value="CATEGORY">
            Sort by Category
          </option>

          <option value="TASK_COUNT">
            Sort by Task Count
          </option>
        </select>

      </div>

    </div>
  );
};

export default TemplateFilterBar;